import React from 'react';
import { Link } from 'react-router-dom';
// Assets
import Icon from 'assets/Icon';
// Styles
import styles from './style/drawerNavItem.module.css';

interface DrawerNavItemProps {
  href: string,
  icon: string,
  iconBackground?: string,
  iconFill?: string,
  label?: string,
}

function DrawerNavItem({
  href,
  icon,
  iconBackground,
  iconFill,
  label,
}:DrawerNavItemProps) {
  return (
    <Link to={href}>
      <div className={styles.container}>
        <div className={`${styles.icon} ${iconBackground ? styles[iconBackground] : ''}`}>
          <Icon icon={icon} fill={iconFill || 'white'} />
        </div>
        <span className="small-print">{ label }</span>
      </div>
    </Link>
  );
}

DrawerNavItem.defaultProps = {
  iconBackground: '',
  iconFill: '',
  label: '',
}

export default DrawerNavItem;
